import DOMPurify from 'dompurify';

DOMPurify.addHook('uponSanitizeAttribute', function (node, data) {
    if (data.attrName === 'style') {
        const styleValue = data.attrValue;
        // Loại bỏ style nguy hiểm như javascript: trong url hoặc expression()
        if (/expression|url\s*\(\s*javascript:/i.test(styleValue)) {
            data.keepAttr = false;
        }
    }
});

export function sanitizeHtml(html) {
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            "a", "b", "i", "u", "em", "strong", "p", "br", "ul", "ol", "li",
            "span", "div", "blockquote", "code", "pre", "img",
            "h1", "h2", "h3", "h4", "h5", "h6", "ins"
        ],
        ALLOWED_ATTR: [
            "href", "title", "target", "rel", // for <a>
            "src", "alt",                     // for <img>
            "style"                           // allow inline style (sanitize separately)
        ],
        ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
        FORCE_BODY: true,
        KEEP_CONTENT: false,
        RETURN_TRUSTED_TYPE: false
    });

}
